export default {
  '9231ee25b0984ec4a3f91ffbe56786eb': '还没选够赠品哦',
  '66ee61e22d3270ba37dd28b22ea0151d': '促销商品详情页_赠品选择',
  b6a29f60129c867d3c91fb196fe1be47: '原价',
  e00ec5caafbdeeaea86f898eecf81f5a: '请选择商品',
  cc743ad271e57939f390074b7a93d072: '已售罄',
  '4a26e922ec195bf003c5c486f1a011c2': '0元签约',
  '116e491a459350c4d6f6b51e7b9d2c49': '确定',
  b09069a95d7f2ef659e01a90323ecb84: '促销订阅方式选择',
  '3f0a50e2ec7f044f2a70e8777718e353': '订阅',
  be747cb7f5901629ce6a0408e6976c54: '推荐',
  '3fce0224ae8157036a3ad2223ccdd347': '促销商品详情页_SKU选择抽屉_选择商品',
  '897a98f3fb07a2bc17a078d648647e62': '请选',
  fb431249bf33c4e9bab8360fa8fab53e: '件'
};
